import { sortedUniq, sum, round, max, min } from "lodash";
import { eachDay, format } from 'date-fns'
import { convertMinutesToTimeJp } from "../../../../lib/convert";

class TrackingItem {
    readonly date: string
    readonly value: number
    readonly sumTotalExamValue: number
    readonly manuallyChanged: boolean

    constructor(data: { [key: string]: any }) {
        this.date = data.date
        this.value = data.value
        this.sumTotalExamValue = data.sumTotalExamValue
        this.manuallyChanged = data.manuallyChanged ?? false
    }
}

export default class UserTrackingData {
    readonly activities: TrackingItem[] = []
    readonly trackingUsers: TrackingItem[] = []
    readonly consecutiveDayCount: number

    constructor(data: { [key: string]: any }) {
        if (data.activities) {
            this.activities = data.activities.map((element) => new TrackingItem(element))
        }
        if (data.trackingUsers) {
            this.trackingUsers = data.trackingUsers.map((element) => new TrackingItem(element))
        }

        this.consecutiveDayCount = data.consecutiveDayCount || 0
    }

    get labels(): string[] {
        const dates = [...this.activities.map(item => item.date), ...this.trackingUsers.map(item => item.date)]
        const maxDate = max(dates)
        const minDate = min(dates)

        return eachDay(new Date(minDate),new Date(maxDate)).map(item => format(item, "YYYY-MM-DD"))

        // return sortedUniq([...this.activities.map(item => item.date), ...this.trackingUsers.map(item => item.date)])
    }

    get activitieAverage(): number {
        if (this.labels.length == 0) {
            return 0;
        }

        return round(sum(this.activitieValues) / this.labels.length, 2)
    }

    get activitieValues(): number[] {
        const values = []

        return this.labels.map(label => {
            const found = this.activities.find(item => item.date == label)
            return found ? found.value : 0;
        });
    }

    get trackingUserAverage(): number {
        if (this.labels.length == 0) {
            return 0;
        }

        return round(sum(this.trackingUserValues) / this.labels.length, 0)
    }

    get trackingUserValues(): number[] {
        const values = []

        return this.labels.map(label => {
            const found = this.trackingUsers.find(item => item.date == label)
            if (!found) {
                return 0
            }
            const minutes = Math.round(found.value / 60)
            return minutes
        });
    }


    // The learner set this day's time by hand; show it as-is instead of the measured value.
    isManuallyChanged(date: string): boolean {
        return this.trackingUsers.some(item => item.date == date && item.manuallyChanged)
    }

    get trackingUserExamValues(): number[] {
        const values = []

        return this.labels.map(label => {
            const found = this.trackingUsers.find(item => item.date == label)
            if (!found) {
                return 0
            }
            return found.sumTotalExamValue
        });
    }

    get trackingUserValueJp(): string[] {
        return this.trackingUserValues.map(minutes => {
            return convertMinutesToTimeJp(minutes)
        });
    }
}
